<template>
    <table
        class="table"
        :class="{ 'table-wide': layoutOptions.layout_style === 'none'}"
    >
        <thead>
        <tr>
            <th scope="col">Lead</th>
            <th scope="col">Status</th>
            <th scope="col">Converted to</th>
            <th scope="col">Date</th>
        </tr>
        <tr class="h-1"/>
        </thead>
        <tbody>
        <tr
            v-for="(lead, index) in leads"
            class="hover:bg-gray-100 hover:bg-opacity-50"
        >
            <td class="whitespace-nowrap">
                <div class="font-medium group-hover:underline"
                     :class="'group-hover:text-' + isCustomColor(layoutOptions.link_color) ? 'custom-link' : layoutOptions.link_color">
                    <span class="">{{ lead.lead_info.name }}</span>
                </div>
                <div class="font-medium group-hover:underline"
                     :class="'group-hover:text-' + isCustomColor(layoutOptions.link_color) ? 'custom-link' : layoutOptions.link_color">
                    <span class="opacity-60">{{ lead.lead_info.email }}</span>
                </div>
            </td>
            <td class="font-medium whitespace-nowrap">
                <lead-status :status="lead.status_raw"/>
            </td>
            <td class="font-medium whitespace-nowrap">
                <div v-if="lead.converted_to">
                    <a :href="lead.converted_to.url">{{ lead.converted_to.name }}</a>
                </div>
                <div v-else class="font-medium group-hover:underline">
                    <span>-</span>
                </div>
            </td>

            <td class="whitespace-nowrap">
                <time
                    class="opacity-60"
                    :datetime="lead.created_at"
                >
                    {{ lead.created_at }}
                </time>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import useFiltersAndPagination from "../../../../state/common/filters-and-pagination";
import filtersAndPaginationData from "../../../../composables/common/filter-and-pagination-data";
import useTranslationSettings from "../../../../state/portal/portal-translation-settings";
import {isCustomColor} from "../../../../helpers/common";
import LeadStatus from "../../../common/LeadStatus.vue";
import ProgressBar from "../../../../elements/ProgressBar";

export default {
    name: "LeadsDataTable",
    components: {
        ProgressBar,
        LeadStatus
    },
    props: ['leads'],
    setup() {
        const {layoutOptions} = useFiltersAndPagination();
        const {loadingFiltersAndPaginationData} = filtersAndPaginationData();
        const {portalTranslationSettings} = useTranslationSettings();

        return {layoutOptions, loadingFiltersAndPaginationData, portalTranslationSettings}
    },
    methods: {
        isCustomColor
    }
}
</script>
